import { normalizeAddress } from "@dune/utils";
import { useFormContext } from "react-hook-form";
import { ConstructionSiteDetailsFormData } from "./useConstructionSiteDetailsForm";
import { cn } from "@dune/ui";

interface RisquesAssociesBlockProps {
	className?: string;
}

const RisquesAssociesBlock = ({
	className,
}: RisquesAssociesBlockProps) => {
	const { watch } = useFormContext<ConstructionSiteDetailsFormData>();

	const {
		rga,
		sismic,
		streetNumber,
		streetName,
		postalCode,
		city,
		georisquesAddress,
		georisquesErrorMessage,
	} = watch();

	const formAddress = normalizeAddress(
		streetNumber,
		streetName,
		postalCode,
		city,
	);
	const georisquesAddressNormalized = georisquesAddress
		? normalizeAddress(
				georisquesAddress.streetNumber,
				georisquesAddress.streetName,
				georisquesAddress.postalCode,
				georisquesAddress.city,
			)
		: "";

	const isAddressDifferent =
		formAddress &&
		georisquesAddressNormalized &&
		formAddress !== georisquesAddressNormalized;

	return (
		<div className={cn("flex flex-col gap-4", className)}>
			<h1 className="text-[#144C65] text-md font-medium">
				Risques associés
			</h1>
			{(georisquesAddress &&
				(georisquesAddress.streetName ||
					georisquesAddress.postalCode ||
					georisquesAddress.city)) ||
			georisquesErrorMessage ? (
				<div
					className={`text-sm text-gray-600 italic ${
						isAddressDifferent
							? "border-2 border-red-500 rounded-lg p-4"
							: ""
					}`}
				>
					<p>Adresse utilisée pour le calcul des risques :</p>
					{georisquesErrorMessage ? (
						<p className="text-destructive font-medium">
							{georisquesErrorMessage}
						</p>
					) : (
						georisquesAddress && (
							<p>
								<b>
									{[
										georisquesAddress.streetNumber,
										georisquesAddress.streetName,
										georisquesAddress.postalCode,
										georisquesAddress.city,
									]
										.filter(Boolean)
										.join(" ")}
								</b>
							</p>
						)
					)}
				</div>
			) : null}
			<div className="flex flex-col border-solid border-1 border-gray-200 rounded-lg p-6 gap-4 bg-gray-100">
				<div className="flex flex-row items-center space-x-2 justify-between">
					<p>Risque de gonflement et retrait des argiles (RGA)</p>
					<RiskBadge riskCode={rga} />
				</div>
				<div className="flex flex-row items-center space-x-2 justify-between">
					<p>Sismique</p>
					<RiskBadge riskCode={sismic} />
				</div>
			</div>
		</div>
	);
};

const RiskBadge = ({ riskCode }: { riskCode?: number }) => {
	switch (riskCode) {
		case 0:
			return (
				<div className="rounded-2xl px-2 py-1 bg-blue-600 text-white">
					Très Faible
				</div>
			);
		case 1:
			return (
				<div className="rounded-2xl px-2 py-1 bg-green-600 text-white">
					Faible
				</div>
			);
		case 2:
			return (
				<div className="rounded-2xl px-2 py-1 bg-orange-600 text-white">
					Modéré
				</div>
			);
		case 3:
			return (
				<div className="rounded-2xl px-2 py-1 bg-red-600 text-white">Elevé</div>
			);
		default:
			return (
				<div className="rounded-2xl px-2 py-1 bg-gray-400 text-white">Non</div>
			);
	}
};

export default RisquesAssociesBlock;
